export class Accounts {
  constructor(financeTypes, form, items) {
    this.financeTypes = financeTypes;
    this.form = form;

    if (items) {
      this.accounts = items;
    } else {
      this.accounts = [this.getDefaultAccountObject()];
    }
  }

  add(number, type) {
    if (this.accounts.length > 1) {
      return;
    }
    if (number && type) {
      /*
      if we initial pushed an object with empty values to account array and
      want to add specific values, we can fill the 'empty object' with values.
       */
      if (this.accounts && !this.accounts[0].number) {
        this.accounts.pop();
      }

      this.accounts.push({
        number: number,
        type: type
      });
    } else {
      this.accounts.push(this.getDefaultAccountObject());
    }
  }

  remove() {
    if (this.accounts.length <= 1) {
      return;
    }
    this.accounts.pop();
  }

  getDefaultAccountObject() {
    let defaultObject = {
      number: null,
      type: this.financeTypes[0]
    };
    if (this.accounts && this.accounts.length <= 1) {
      // not proud of this
      if (this.accounts[0].type === this.financeTypes[0]) {
        defaultObject.type = this.financeTypes[1];
      } else {
        defaultObject.type = this.financeTypes[0];
      }
    }
    return defaultObject;
  }

  getItem(i) {
    return this.accounts[i];
  }

  copyAccountsToObject(model) {
    for (let key in model) {
      model[key] = null;
    }

    for (let i = this.accounts.length - 1; i >= 0; i--) {
      model[this.accounts[i].type] = this.accounts[i].number;
    }
    return model;
  }

  get all() {
    return this.accounts;
  }

  get length() {
    return this.accounts.length;
  }

  get bothAccountsHaveSameType() {
    return (this.accounts.length > 1
    && this.accounts[0].type === this.accounts[1].type);
  }

  get bothAccountsHaveSameNumber() {
    return this.accounts.length > 1
    && this.accounts[0].number === this.accounts[1].number;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/start/accounts.js